import React from 'react';
import { useTranslation } from 'react-i18next';
import AutocompleteFilter, { FilterOption } from '../../transactions/filters/AutocompleteFilter';

interface SmartCheckYearFilterProps {
    years: Array<{ year: number; count: number }>;
    value: number[];
    onChange: (value: number[]) => void;
}

const SmartCheckYearFilter: React.FC<SmartCheckYearFilterProps> = ({ years, value, onChange }) => {
    const { t } = useTranslation();

    const options: FilterOption[] = years.map(({ year, count }) => ({
        id: year.toString(),
        label: `${year} (${count})`,
    }));

    const handleChange = (newValue: string[]) => {
        onChange(newValue.map(v => parseInt(v)));
    };

    return (
        <AutocompleteFilter
            options={options}
            value={value.map(v => v.toString())}
            onChange={handleChange}
            label={t('smartCheck.table.taxYear', 'Tax Year')}
            placeholder={t('smartCheck.table.taxYear', 'Tax Year')}
            sx={{ maxWidth: '250px', minWidth: '200px' }}
        />
    );
};

export default SmartCheckYearFilter;
